/* eslint-disable no-underscore-dangle,max-lines */
/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d

import { call, takeLatest, takeEvery, put, delay, select } from 'redux-saga/effects';
import has from 'lodash/has';
import logger from '@tcp/core/src/utils/loggerInstance';
import {
  getProductDetails,
  getTotalItemCount,
} from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.selectors';
import { setClickAnalyticsData, trackClick } from '@tcp/core/src/analytics/actions';
import setLoaderState from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import { isCanada, getDateObject } from '@tcp/core/src/utils';
import { getFavoriteStore } from '@tcp/core/src/components/common/organisms/PickupStoreModal/container/PickUpStoreModal.selectors';
import {
  getBonusPointsDayCouponIndex,
  getAllCoupons as getAllCouponSelector,
  getAllLastAppliedCoupon,
  getNormalCoupons,
  getLoyaltyBenefits,
} from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/Coupon.selectors';
import { hasGiftOptionWithPromotion } from '@tcp/core/src/services/abstractors/SFCC/ApplyCoupon.js';
import { getTierBenefits } from '@tcp/core/src/components/features/account/PlaceRewards/container/PlaceRewards.saga.js';
import { getLoyaltyTierBenefits } from '@tcp/core/src/components/features/account/PlaceRewards/container/PlaceRewards.selectors.js';
import {
  getAccountDrawerMyCouponsCacheTTL,
  getcouponOnHoldNewDesign,
  getcouponOnHoldEmptyCartEnabled,
  getIsBonusPointDayEnabled,
  getCouponExpiryTimeDifference,
  getIsSiteWidePromoAbTestEnabled,
  getDeviceSpecificCouponList,
  getDateFixForMultiuseCoupons,
  getIsItemLevelOnHoldMsgEnabled,
  getIsLoyaltyTieringEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';

import {
  setGetCouponDetailsLoader,
  setAppliedCOuponStatus,
  setBonusPointDay,
  callCouponAction,
  toggleMultiAddCouponLoader,
  setMultiAddSuccess,
  setMultiAddCouponError,
} from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/Coupon.actions';
import { getCartItemCount } from '@tcp/core/src/utils/cookie.util';
import CHECKOUT_ACTIONS from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.action';
import { setLoyaltyOrderItems } from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.actions';
import { getModuleX } from '@tcp/core/src/services/abstractors/common/moduleX';
import pushEventToAdobeAnalytics from '../../../../../../../adobeAnalytics/adobe.utils';
import COUPON_CONSTANTS, {
  BONUS_POINT,
  FREE_GIFT_WRAPPING,
  IS_ON_HOLD,
  IS_APPLIED_TO_BASKET,
} from '../Coupon.constants';
import { validateReduxCache } from '../../../../../../../utils/cache.util';
import {
  hideLoader,
  showLoader,
  setStatus,
  setLastAppliedCoupon,
  setError,
  setCouponList,
  setNonLoyaltyCouponList,
  setCouponTermsAndConditions,
  setCouponDetails,
  setCouponDetailsError,
  setApplyCouponCSHError,
} from './Coupon.actions';
import {
  processMutationCachedDataSaga,
  processMutationNonCachedDataSaga,
} from '../../../../BagPage/container/BagPage.saga';
import BagPageSelectors from '../../../../BagPage/container/BagPage.selectors';
import {
  applyCouponToBasket,
  getPromotionDetails,
  removeCouponOrPromo,
  convertExpiryDateToPST,
  isValidEndDate,
  applyMultipleCouponsToBasket,
} from '../../../../../../../services/abstractors/SFCC/ApplyCoupon';
import {
  getAllCoupons as getAllCouponsAbstractor,
  getCouponTermsAndConditions as getCouponTermsAndConditionsAbstractor,
  getCouponDetails as getCouponDetailsAbstractor,
  getBonusPointsDay as getBonusPointsDayAbstractor,
} from '../../../../../../../services/abstractors/CnC/Coupon';
import {
  COUPON_STATUS,
  BUTTON_LABEL_STATUS,
  constructDateUTCFormat,
} from '../../../../../../../services/abstractors/CnC/CartItemTile';
import { recalibrateSectionStates } from '../../../../SinglePageCheckout/container/SinglePageCheckout.actions';
import SpcDynamicStore from '../../../../SinglePageCheckout/container/SpcDynamicStore';
import COUPON_SELF_HELP_CONSTANT from '../../../../../account/CustomerHelp/organisms/TellUsMore/organisms/CouponSelfHelp/CouponSelfHelp.constants';
import { getIsGuest } from '../../../../../account/User/container/User.selectors';
import {
  couponCalculatetax,
  removeCouponFailAction,
  removeCouponSuccessAction,
  resetTaxEstimationValue,
} from '../../../../BagPage/container/BagPage.actions';
import { getContentID } from '../../../../../../../utils/loyalty.util';

export const pageTypeName = (formData) => {
  return formData.analyticsData && formData.analyticsData.pageType
    ? formData.analyticsData.pageType
    : 'shopping bag';
};

export const getOrderFailMatricValue = (isFailed) => (isFailed ? '1' : '');
export const getOrderSuccessMatricValue = (isFailed) => (isFailed ? '' : '1');

export const getTrackingObj = (fromCSH, formData, productsData, coupon, storeId, isFailed) => {
  const pageSectionName = pageTypeName(formData);
  const event27 = 'event27';
  const event28 = 'event28';
  let events;
  let cm152;
  let cm153;
  if (fromCSH) {
    cm153 = getOrderFailMatricValue(isFailed);
    cm152 = getOrderSuccessMatricValue(isFailed);
    events = isFailed ? 'event153' : 'event152';
  } else {
    events = isFailed ? event27 : event28;
  }
  if (!isFailed) {
    pushEventToAdobeAnalytics('coupon_success', coupon);
  }
  const eventNameStr = isFailed ? 'invalid coupon code used' : 'coupon applied';

  return {
    customEvents: [events],
    products: productsData,
    eventName:
      formData.analyticsData && formData.analyticsData.eventName
        ? formData.analyticsData.eventName
        : eventNameStr,
    couponCode: (coupon && coupon.id) || coupon,
    pageNavigationText:
      formData.analyticsData && formData.analyticsData.pageNavigationText
        ? formData.analyticsData.pageNavigationText
        : null,
    storeId,
    pageSection: pageSectionName,
    pageType: pageSectionName,
    pageSubSection: pageSectionName,
    clickEvent: true,
    event152: cm152,
    event153: cm153,
  };
};

const getTrackingObjRemove = (formData, storeId) => {
  return {
    eventName:
      formData.analyticsCustomData && formData.analyticsCustomData.eventName
        ? formData.analyticsCustomData.eventName
        : 'coupon removed',
    pageNavigationText:
      formData.analyticsCustomData && formData.analyticsCustomData.pageNavigationText
        ? formData.analyticsCustomData.pageNavigationText
        : 'bag - remove coupon',
    storeId,
    clickEvent: true,
  };
};

export function* getCartCounts() {
  const cartItemsCookie = yield call(getCartItemCount, true);
  const cartItemsTotal = yield select(getTotalItemCount);
  return cartItemsTotal || parseInt(cartItemsCookie || 0, 10);
}

const getProductData = (cartOrderItems) => {
  const productsData = [];
  if (cartOrderItems) {
    cartOrderItems.map((tile) => {
      const productDetail = getProductDetails(tile);
      const {
        itemInfo: { itemId, color, name, offerPrice, size, listPrice, qty },
        productInfo: { skuId, generalProductId, upc, productPartNumber },
      } = productDetail;

      const prodData = {
        color,
        id: itemId,
        name,
        price: offerPrice,
        extPrice: offerPrice,
        listPrice,
        partNumber: productPartNumber,
        size,
        upc,
        sku: skuId.toString(),
        quantity: qty,
        colorId: generalProductId,
      };
      productsData.push(prodData);
      return prodData;
    });
  }
  return productsData;
};

const getCouponOldStatus = (coupon) => {
  let oldStatus = coupon.status;
  if (coupon.status === COUPON_STATUS.AVAILABLE) {
    oldStatus = BUTTON_LABEL_STATUS.APPLY;
  } else if (coupon.status === COUPON_STATUS.APPLIED) {
    oldStatus = BUTTON_LABEL_STATUS.REMOVE;
  } else if (!oldStatus) {
    // handle the undefined case for DRP-51351. In case of undefined, keep the text as apply
    oldStatus = BUTTON_LABEL_STATUS.APPLY;
  }
  return oldStatus;
};

// eslint-disable-next-line max-statements
// eslint-disable-next-line
export function* applyCoupon({ payload }) {
  const {
    formData,
    formPromise,
    source,
    coupon,
    // fullPageInfo, // SFCC-TODO to remove in future
    // isCheckoutFlow, // SFCC-TODO to remove in future
    isCheckoutFlow,
    fromCartPage,
    fromCSH,
    fromInput,
    fromBagPage,
  } = payload;
  let resolve;
  let reject;

  // handling the formPromise here so that we can able to call it from added to bag saga for apply coupon.
  if (formPromise && formPromise.resolve && formPromise.reject) {
    // eslint-disable-next-line prefer-destructuring
    resolve = formPromise.resolve;
    // eslint-disable-next-line prefer-destructuring
    reject = formPromise.reject;
  }
  yield put(setMultiAddCouponError(null));
  yield call(SpcDynamicStore);
  const cartOrderItems = yield select(BagPageSelectors.getOrderItems);
  const storeId = yield select(getFavoriteStore);
  const isLoyaltyTieringEnabled = yield select(getIsLoyaltyTieringEnabled);
  yield put(CHECKOUT_ACTIONS.setServerErrorCheckout({}));
  const productsData = getProductData(cartOrderItems);

  const cartItemsCount = yield call(getCartCounts);

  if (coupon) {
    const oldStatus = getCouponOldStatus(coupon);
    const isItemLevelOnHoldMsgEnabled = yield select(getIsItemLevelOnHoldMsgEnabled);

    try {
      yield put(setStatus({ promoCode: coupon.id, status: COUPON_STATUS.APPLYING }));
      const labels = yield select(BagPageSelectors.getErrorMapping);
      const isCouponOnHoldEmptyCartEnabled = yield select(getcouponOnHoldEmptyCartEnabled);
      const respToProcess = yield call(
        applyCouponToBasket,
        formData,
        labels,
        cartItemsCount,
        fromCartPage,
        coupon?.fromBonusPointsDay,
        isCouponOnHoldEmptyCartEnabled,
        isLoyaltyTieringEnabled
      );
      if (!isCheckoutFlow) {
        yield put(resetTaxEstimationValue());
      } else {
        yield put(couponCalculatetax(true));
      }
      yield call(processMutationCachedDataSaga, { payload: { respToProcess } });
      yield call(processMutationNonCachedDataSaga, {
        payload: {
          respToProcess,
          isCheckoutFlow: true,
          skipLoyaltyApi: coupon?.fromBonusPointsDay || false,
        },
      });
      // this code handles the scenario where price and promo not showing up on first time when we add a product to cart on added to bag modal.
      if (has(respToProcess, 'productItems')) {
        const priceAdjustments = respToProcess.productItems;
        yield put(setLoyaltyOrderItems(priceAdjustments));
      }
      if (isItemLevelOnHoldMsgEnabled) {
        if (fromBagPage) {
          yield put(setLastAppliedCoupon(coupon.promotionId || coupon.id || formData?.couponCode));
        } else {
          yield put(setLastAppliedCoupon(null));
        }
      }
      yield put(recalibrateSectionStates());
      yield put(
        setClickAnalyticsData(getTrackingObj(fromCSH, formData, productsData, coupon, storeId))
      );

      yield put(
        trackClick({
          name: 'coupon_success',
          module: 'checkout',
        })
      );
      if (resolve) resolve();
      if (fromInput) {
        yield put(setAppliedCOuponStatus(true));
      }
    } catch (e) {
      if (fromInput) {
        yield put(setAppliedCOuponStatus(false));
      }
      if (isItemLevelOnHoldMsgEnabled) {
        yield put(setLastAppliedCoupon(null));
      }
      logger.error({
        error: 'Error while applying coupon',
        extraData: {
          component: 'Coupon Saga - applyCoupon - coupon available',
          errorMessage: JSON.stringify(e),
          fromCartPage,
          fromCSH,
        },
      });
      const ValidationErrorCode = 'error:couponcode';
      pushEventToAdobeAnalytics('coupon_failed', { coupon, ValidationErrorCode });

      yield put(
        setClickAnalyticsData(
          getTrackingObj(fromCSH, formData, productsData, coupon, storeId, true)
        )
      );
      yield put(
        trackClick({
          name: 'coupon_fails',
          module: 'checkout',
        })
      );
      yield put(setStatus({ promoCode: coupon.id, status: oldStatus }));
      if (source !== 'form' && e.errors) {
        if (!fromCSH)
          yield put(setError({ msg: e.errors._error.msg, couponCode: formData.couponCode }));
        else {
          yield put(setApplyCouponCSHError({ msg: e.errors._error.msg }));
        }
      }
      if (reject) reject(e);
    }
  } else {
    try {
      const labels = yield select(BagPageSelectors.getErrorMapping);
      const isCouponOnHoldEmptyCartEnabled = yield select(getcouponOnHoldEmptyCartEnabled);
      const respToProcess = yield call(
        applyCouponToBasket,
        formData,
        labels,
        cartItemsCount,
        fromCartPage,
        null,
        isCouponOnHoldEmptyCartEnabled
      );

      if (!isCheckoutFlow) {
        yield put(resetTaxEstimationValue());
      } else {
        yield put(couponCalculatetax(true));
      }

      yield call(processMutationCachedDataSaga, {
        payload: {
          respToProcess,
        },
      });
      yield call(processMutationNonCachedDataSaga, {
        payload: { respToProcess, isCheckoutFlow: true },
      });
      if (has(respToProcess, 'productItems')) {
        const priceAdjustments = respToProcess.productItems;
        yield put(setLoyaltyOrderItems(priceAdjustments));
      }

      yield put(recalibrateSectionStates());
      yield put(setClickAnalyticsData(getTrackingObj(formData, productsData, null, storeId)));
      yield put(
        trackClick({
          name: 'coupon_success',
          module: 'checkout',
        })
      );
      if (resolve) resolve();
      if (fromInput) {
        yield put(setAppliedCOuponStatus(true));
      }
    } catch (e) {
      if (fromInput) {
        yield put(setAppliedCOuponStatus(false));
      }
      logger.error({
        error: 'Error while applying coupon',
        extraData: {
          component: 'Coupon Saga - applyCoupon - coupon available',
          errorMessage: JSON.stringify(e),
          fromCartPage,
          fromCSH,
        },
      });
      yield put(
        setClickAnalyticsData({
          customEvents: 'event27',
          products: productsData,
          eventName: 'invalid coupon code used',
        })
      );
      yield put(
        trackClick({
          name: 'coupon_fails',
          module: 'checkout',
        })
      );
      if (reject) reject(e);
    }
  }
}

export function* removeCoupon({ payload }) {
  const { coupon, formPromise, fromCartPage, isCheckoutFlow, fromAfterPay } = payload;
  let resolve;
  let reject;
  if (formPromise && formPromise.resolve && formPromise.reject) {
    // eslint-disable-next-line prefer-destructuring
    resolve = formPromise.resolve;
    // eslint-disable-next-line prefer-destructuring
    reject = formPromise.reject;
  }
  yield call(SpcDynamicStore);
  const formData = { couponCode: coupon.id };
  const storeId = yield select(getFavoriteStore);
  const isLoyaltyTieringEnabled = yield select(getIsLoyaltyTieringEnabled);
  const oldStatus = getCouponOldStatus(coupon);
  yield put(setMultiAddCouponError(null));

  try {
    yield put(CHECKOUT_ACTIONS.setServerErrorCheckout({}));
    const errorMapings = yield select(BagPageSelectors.getErrorMapping);
    yield put(setStatus({ promoCode: coupon.id, status: COUPON_STATUS.REMOVING }));
    const respToProcess = yield call(
      removeCouponOrPromo,
      formData,
      errorMapings,
      fromCartPage,
      coupon?.fromBonusPointsDay,
      isLoyaltyTieringEnabled
    );
    const lastAppliedCoupon = yield select(getAllLastAppliedCoupon);
    if (coupon.id === lastAppliedCoupon) {
      yield put(setLastAppliedCoupon(null));
    }
    yield call(processMutationCachedDataSaga, {
      payload: {
        respToProcess,
      },
    });
    yield call(processMutationNonCachedDataSaga, {
      payload: {
        respToProcess,
        isCheckoutFlow: true,
        skipLoyaltyApi: coupon?.fromBonusPointsDay || false,
      },
    });
    // this code handles the scenario where price and promo shows discounted price and promo applied when we remove the promo.
    if (has(respToProcess, 'productItems')) {
      const priceAdjustments = respToProcess.productItems;
      yield put(setLoyaltyOrderItems(priceAdjustments));
    }
    yield put(setStatus({ promoCode: coupon.id, status: BUTTON_LABEL_STATUS.APPLY }));

    if (!isCheckoutFlow) {
      yield put(resetTaxEstimationValue());
    } else {
      yield put(couponCalculatetax(true));
    }
    yield put(recalibrateSectionStates());
    yield put(setClickAnalyticsData(getTrackingObjRemove(payload, storeId)));
    yield put(
      trackClick({
        name: 'coupon_removed',
        module: 'checkout',
      })
    );
    pushEventToAdobeAnalytics('remove_coupon_code', coupon?.id);
    yield put(removeCouponSuccessAction(true));

    if (resolve) resolve();
  } catch (e) {
    const errorMapping = yield select(BagPageSelectors.getErrorMapping);

    if (fromAfterPay) {
      yield put(
        CHECKOUT_ACTIONS.setServerErrorCheckout({
          errorMessage: errorMapping.ERR_PLCC_INELIGIBLE_PROMOTION,
          component: 'PAGE',
        })
      );
    }
    yield put(removeCouponFailAction(true));
    yield put(setStatus({ promoCode: coupon.id, status: oldStatus }));
    // eslint-disable-next-line
    yield put(setError({ msg: e.errors._error.msg, couponCode: formData.couponCode }));
    yield delay(5000);
    yield put(setError({ msg: null, couponCode: formData.couponCode }));
    if (reject) reject(e);
  }
}

const getCodeDetails = (couponPipedValue) => {
  const [stamp = '', type = '', startDate = '', endDate = '', status = '', couponValue = null] =
    couponPipedValue.split('|');
  return { stamp, type, startDate, endDate, status, couponValue };
};
export const getCouponCodeTypeMap = (coupons) => {
  const couponObj = JSON.parse(coupons);
  const couponCodeTypeMap = Object.keys(couponObj) || [];
  return couponCodeTypeMap.map((ele) => {
    return { code: ele, ...getCodeDetails(couponObj[ele]) };
  });
};

const statusApplied = (record) => {
  return record.status === COUPON_STATUS.APPLIED;
};

const statusOnHold = (record) => {
  return record.status === COUPON_STATUS.NO_APPLICABLE_PROMOTION;
};

const statusNoActivePromotion = (record) => {
  return record?.status === COUPON_STATUS?.NO_ACTIVE_PROMOTION;
};

const statusNonActiveAnd = (record) => {
  return (
    record.status === COUPON_STATUS.NO_ACTIVE_PROMOTION ||
    record.status === COUPON_STATUS.NO_APPLICABLE_PROMOTION ||
    statusApplied(record)
  );
};

function getDateValue(coupon) {
  return new Date(coupon?.expirationDate);
}

function sortCouponsByExpirationDate(couponA, couponB) {
  return getDateValue(couponA) - getDateValue(couponB);
}

function processCoupons({ allCoupons, listOfAppliedCoupon, isCouponOnHoldNewDesignEnabled }) {
  let coupons = JSON.parse(JSON.stringify(allCoupons));
  coupons = coupons.map((coupon) => {
    const currentCoupon = listOfAppliedCoupon?.find((record) => record.code === coupon.id);
    const isOnHold = currentCoupon && statusOnHold(currentCoupon);
    if (isOnHold) {
      return {
        ...coupon,
        isOnHold: isCouponOnHoldNewDesignEnabled ? 'true' : 'false',
        status: isCouponOnHoldNewDesignEnabled ? COUPON_STATUS.AVAILABLE : COUPON_STATUS.APPLIED,
        labelStatus: BUTTON_LABEL_STATUS.REMOVE,
      };
    }
    const isApplied = currentCoupon && statusApplied(currentCoupon);

    return {
      ...coupon,
      isOnHold: isApplied ? 'false' : coupon.isOnHold,
      status: isApplied ? COUPON_STATUS.APPLIED : coupon.status,
      isApplied,
    };
  });
  return coupons;
}

export function* updateOnHoldCoupons(value) {
  const { payload = {} } = value;
  const { appliedCoupons = '', isCouponOnHoldNewDesignEnabled } = payload;
  try {
    const allCoupons = yield select(getAllCouponSelector);
    if (allCoupons && allCoupons?.size > 0) {
      const listOfAppliedCoupon = appliedCoupons ? getCouponCodeTypeMap(appliedCoupons) : [];
      const coupons = processCoupons({
        allCoupons,
        listOfAppliedCoupon,
        isCouponOnHoldNewDesignEnabled,
      });

      const couponCachingTTL = yield select(BagPageSelectors.getCouponCachingTTL);
      yield put(setCouponList({ coupons, couponCachingTTL }));
    }
  } catch (e) {
    logger.error('updateOnHoldCoupons error', e);
  }
}

export function* handleBasketError(error, totalPlaceBucksCoupon) {
  const { errorCode, errorMessage, errorParameters } = error;
  const labels = yield select(BagPageSelectors.getErrorMapping);
  let errMsg = labels?.[errorCode] || errorMessage;

  if (
    errorCode === 'TCP_PROMOTION_THRESHOLD_NOT_MET' ||
    errorCode === 'TCP_PROMOTION_REDEMPTION_REACHED'
  ) {
    const cpnNotApplied = totalPlaceBucksCoupon - (errorParameters?.APPLIED_COUPON_COUNT || 0);
    errMsg = errMsg.replace('#couponCount', cpnNotApplied);

    if (errorCode === 'TCP_PROMOTION_THRESHOLD_NOT_MET') {
      errMsg = errMsg.replace('#amount', errorParameters?.AMOUNT_MISSING || '0');
    }
  }

  return {
    errorCode,
    errorMessage: errMsg,
    errorParameters,
  };
}

export function* applyMultipleCouponsSaga(value) {
  const { payload = {} } = value;
  try {
    yield put(setMultiAddCouponError(null));
    const errorMapping = yield select(BagPageSelectors.getErrorMapping);

    yield put(toggleMultiAddCouponLoader(true));
    const parsedCouponCodesArray = payload && JSON.parse(JSON.stringify(payload));
    const cpnCodeToProcess = parsedCouponCodesArray?.slice(0, 12);
    const respToProcess = yield call(applyMultipleCouponsToBasket, cpnCodeToProcess, errorMapping);
    const totalPlaceBucksCoupon = payload?.size;
    if (respToProcess?.basketError) {
      const error = yield call(
        handleBasketError,
        respToProcess?.basketError,
        totalPlaceBucksCoupon
      );

      yield put(setMultiAddCouponError(error));
    }
    yield call(processMutationCachedDataSaga, { payload: { respToProcess } });
    yield call(processMutationNonCachedDataSaga, {
      payload: { respToProcess, isCheckoutFlow: true },
    });
    yield put(toggleMultiAddCouponLoader(false));
    yield put(setMultiAddSuccess(true));
  } catch (e) {
    yield put(toggleMultiAddCouponLoader(false));
    yield put(setMultiAddSuccess(false));
    const errorMapping = yield select(BagPageSelectors.getErrorMapping);
    const errorCode = e?.errors?.errorCode || '';
    let errorMessage = '';
    errorMessage = errorMapping?.[errorCode] || '';
    yield put(
      setMultiAddCouponError({
        errorMessage: errorMessage || errorMapping.DEFAULT,
      })
    );
  }
}

export function* updateExpireCoupons(value) {
  const { payload = {} } = value;
  const { appliedCoupons = '' } = payload;
  try {
    const allCoupons = yield select(getAllCouponSelector);
    if (allCoupons && allCoupons?.size > 0) {
      const listOfAppliedCoupon = appliedCoupons ? getCouponCodeTypeMap(appliedCoupons) : [];
      let coupons = JSON.parse(JSON.stringify(allCoupons));
      coupons = coupons.map((coupon) => {
        const isExpired = listOfAppliedCoupon.findIndex(
          (record) => record.code === coupon.id && statusNoActivePromotion(record)
        );
        return {
          ...coupon,
          status: isExpired !== -1 ? 'notActive' : coupon.status,
        };
      });

      const couponCachingTTL = yield select(BagPageSelectors.getCouponCachingTTL);
      yield put(setCouponList({ coupons, couponCachingTTL }));
    }
  } catch (e) {
    logger.error('updateExpireCoupons error', e);
  }
}

function getLastDayOfYear() {
  const currentDate = new Date();
  const year = currentDate?.getFullYear();
  const lastDayOfYear = new Date(year, 11, 31);

  const month = lastDayOfYear?.getMonth() + 1;
  const day = lastDayOfYear?.getDate();
  const twoDigitYear = year % 100;

  return `${month}/${day}/${twoDigitYear < 10 ? '0' : ''}${twoDigitYear}`;
}

function getLastMomentOfYear() {
  const currentDate = new Date();
  const year = currentDate?.getFullYear();
  const lastMomentOfYear = new Date(Date?.UTC(year, 11, 31, 23, 59, 59, 999));

  return lastMomentOfYear?.toISOString();
}

function* getCouponsList(
  guestUser,
  fromPlcc,
  isSourceLogin,
  deviceSpecificCoupon,
  isSiteWidePromoAbtestEnabled
) {
  if (isSiteWidePromoAbtestEnabled || !guestUser || fromPlcc) {
    return yield call(getAllCouponsAbstractor, isSourceLogin, deviceSpecificCoupon);
  }
  return [];
}

function processCouponStatus(coupons, listOfAppliedCoupon) {
  return coupons.map((cpn) => {
    const coupon = cpn;
    let cpMatched = -1;
    let cpOnHold = -1;
    let cpNoActivePromotion = -1;
    if (listOfAppliedCoupon && listOfAppliedCoupon.length) {
      cpMatched = listOfAppliedCoupon.findIndex(
        (record) => record.code === cpn.id && statusApplied(record)
      );
      cpOnHold = listOfAppliedCoupon.findIndex(
        (record) => record.code === cpn.id && statusOnHold(record)
      );
      cpNoActivePromotion = listOfAppliedCoupon?.findIndex(
        (record) => record?.code === cpn?.id && statusNoActivePromotion(record)
      );
    }
    if (cpOnHold !== -1) {
      coupon.labelStatus = BUTTON_LABEL_STATUS.REMOVE;
      listOfAppliedCoupon.splice(cpOnHold, 1);
    }
    if (cpMatched !== -1) {
      coupon.status = COUPON_STATUS.APPLIED;
      coupon.labelStatus = BUTTON_LABEL_STATUS.REMOVE;
      listOfAppliedCoupon.splice(cpMatched, 1);
    }

    if (cpNoActivePromotion !== -1) {
      coupon.status = 'notActive';
      coupon.labelStatus = 'notActive';
      listOfAppliedCoupon?.splice(cpNoActivePromotion, 1);
    }
    return coupon;
  });
}

function* getNonWalletCouponList(
  listOfAppliedCoupon,
  isCouponOnHoldNewDesignEnabled,
  couponExpiryTimeDiff,
  coupons
) {
  if (
    listOfAppliedCoupon &&
    listOfAppliedCoupon.length &&
    listOfAppliedCoupon.findIndex((record) => statusNonActiveAnd(record)) !== -1
  ) {
    const labels = yield select(BagPageSelectors.getErrorMapping);
    const couponDescriptonFromPriceAdjustments = yield select(
      BagPageSelectors.getCouponDescriptonFromPriceAdjustments
    );
    const nonWalletCouponList = yield call(
      getPromotionDetails,
      listOfAppliedCoupon,
      labels,
      isCouponOnHoldNewDesignEnabled,
      couponExpiryTimeDiff,
      couponDescriptonFromPriceAdjustments
    );
    return [...coupons, ...nonWalletCouponList];
  }
  return coupons;
}

function couponStatusUpdate({
  coupons,
  listOfAppliedCoupon,
  couponExpiryTimeDiff,
  isCouponOnHoldNewDesignEnabled,
  isSiteWidePromoAbtestEnabled,
  isDateFixForMultiuseEnabled,
}) {
  return coupons?.map((cpn) => {
    const coupon = cpn;
    let cpNoActivePromotion = -1;
    let isOnHold = -1;
    if (listOfAppliedCoupon && listOfAppliedCoupon.length) {
      cpNoActivePromotion = listOfAppliedCoupon?.findIndex(
        (record) => record?.code === cpn?.id && statusNoActivePromotion(record)
      );
      isOnHold = listOfAppliedCoupon?.findIndex(
        (record) => record?.code === cpn?.id && statusOnHold(record)
      );
    }
    if (cpNoActivePromotion !== -1) {
      coupon.status = 'notActive';
      coupon.labelStatus = 'notActive';
      listOfAppliedCoupon?.splice(cpNoActivePromotion, 1);
    }

    if (isOnHold !== -1 && !isCouponOnHoldNewDesignEnabled) {
      coupon.isOnHold = 'false';
      coupon.status = COUPON_STATUS.APPLIED;
      coupon.labelStatus = BUTTON_LABEL_STATUS.REMOVE;
      listOfAppliedCoupon?.splice(isOnHold, 1);
    }
    if (
      (isSiteWidePromoAbtestEnabled || isDateFixForMultiuseEnabled) &&
      coupon.couponType === 'MULTIUSE'
    ) {
      const now = getDateObject();
      const oneDay = 24 * 60 * 60 * 1000;
      const expirationThreshold = 7;
      const endDatepst = convertExpiryDateToPST(coupon.expirationDate, couponExpiryTimeDiff);
      if (isValidEndDate(endDatepst)) {
        coupon.expirationDate = constructDateUTCFormat(endDatepst);
        coupon.isExpiring =
          Math.round(Math.abs((endDatepst.getTime() - now.getTime()) / oneDay)) <=
          expirationThreshold;
      }
    }
    return coupon;
  });
}

const BONUS_POINT_DAY = 'BONUS-POINT-DAY';

function* couponUpdateBPD(guestUser, coupons) {
  const bonusPointDay = !guestUser && !isCanada() ? yield call(getBonusPointsDayAbstractor) : [];
  yield put(setBonusPointDay(bonusPointDay));
  const bonusPointDayIndex = yield select(getBonusPointsDayCouponIndex);
  const couponCards = [];
  const totalBonusPointsDayCard = bonusPointDay?.availableBPD;
  const lastDayOfYear = getLastDayOfYear();
  const lastMomentOfYear = getLastMomentOfYear();

  for (let i = 0; i < totalBonusPointsDayCard; i += 1) {
    const bonusPointDayStructuredData = {
      id: `bonus-${i}`,
      status:
        bonusPointDay?.isBPDAppliedToBasket && i === bonusPointDayIndex ? 'applied' : 'available',
      labelStatus:
        bonusPointDay?.isBPDAppliedToBasket && i === bonusPointDayIndex ? 'REMOVE' : 'APPLY',
      isExpiring: false,
      title: '2X Bonus Points Day',
      detailsOpen: false,
      expirationDate: lastDayOfYear,
      effectiveDate: '',
      details: null,
      legalText: '',
      isStarted: true,
      offerType: 'placeperks',
      error: '',
      promotionType: 'public',
      expirationDateTimeStamp: lastMomentOfYear,
      isExpired: false,
      isApplied: bonusPointDay?.isBPDAppliedToBasket,
      promotionId: 'BonusPointDay',
      isOnHold: 'false',
      originalOfferType: BONUS_POINT_DAY,
      mobileCouponError: '',
      isRedeemed: false,
      couponType: null,
      perkLevel: 'BONUSPOINTDAY',
      isBPDBlackoutDay: bonusPointDay?.isBPDBlackoutDay,
      fromBonusPointsDay: true,
      availableToday: bonusPointDay?.availableBPDToday,
      couponIndex: i,
    };
    couponCards.push(bonusPointDayStructuredData);
  }
  return [...coupons, ...couponCards];
}

function calculateRemainingCounts(benefits) {
  const remainingCounts = {};

  benefits?.forEach((item) => {
    if (item.type === BONUS_POINT || item.type === FREE_GIFT_WRAPPING) {
      const totalCount = parseInt(item?.totalCount, 10);
      const usedCount = parseInt(item?.usedCount, 10);
      const remainingCount = totalCount - usedCount;

      const key = `${item.type}`;
      remainingCounts[key] = remainingCount;
    }
  });

  return remainingCounts;
}
function getValueFromResponse(benefits, type, keyName) {
  const benefit = benefits.find((item) => item?.type === type);
  return benefit ? benefit[keyName] : null;
}

function getStatus(benefits, type) {
  const isExpired = getValueFromResponse(benefits, type, 'isExpired');
  if (isExpired) {
    return 'notActive';
  }

  if (getValueFromResponse(benefits, type, IS_APPLIED_TO_BASKET)) {
    return 'applied';
  }

  return 'available';
}

function getExpirationDate(benefits, type) {
  const benefit = benefits.find((item) => item?.type === type);
  const dateStr = benefit.expirationDate;
  const [year, month, day] = dateStr.split('-');
  const monthPadded = month.padStart(2, '0');
  const dayPadded = day.padStart(2, '0');
  const shortYear = year.slice(-2);
  return `${monthPadded}/${dayPadded}/${shortYear}`;
}

function siteWideCpnCheck({ isSiteWidePromoAbtestEnabled, couponsArray }) {
  let coupons;
  if (!isSiteWidePromoAbtestEnabled) {
    coupons = couponsArray?.filter(
      (cpn) => cpn?.couponType !== 'MULTIUSE' || cpn?.isApplied || cpn?.isOnHold === 'true'
    );
  } else {
    coupons = couponsArray;
  }

  if (isSiteWidePromoAbtestEnabled) {
    // for displaying multiuse coupon as first in the list
    coupons = coupons?.reduce((acc, item) => {
      let couponArray = acc;
      if (item?.couponType === 'MULTIUSE') {
        couponArray = [item, ...couponArray]; // Add multiuse coupon to the beginning
      } else {
        couponArray.push(item); // Add non-multiuse coupon to the end
      }
      return couponArray;
    }, []);
  }
  return coupons;
}

function getFilteredAndSortedCouponList(coupons) {
  const couponTypes = ['LOYALTY', 'PERKS-LOYALTY'];
  const bonusPointDayCoupon = 'BONUS-POINT-DAY';
  const implicitCoupon = 'PERKS-IMPLICIT';

  const loyaltyCoupons = coupons
    ?.filter((coupon) => couponTypes?.includes(coupon?.originalOfferType))
    ?.sort(sortCouponsByExpirationDate);

  const bonusPointDayCoupons = coupons
    ?.filter((coupon) => coupon?.originalOfferType === bonusPointDayCoupon)
    ?.sort(sortCouponsByExpirationDate);

  const implicitCoupons = coupons
    ?.filter((coupon) => coupon?.originalOfferType === implicitCoupon)
    ?.sort(sortCouponsByExpirationDate);

  const remainingCoupons = coupons
    ?.filter(
      (coupon) =>
        !couponTypes?.includes(coupon?.originalOfferType) &&
        coupon?.originalOfferType !== bonusPointDayCoupon &&
        coupon?.originalOfferType !== implicitCoupon
    )
    ?.sort(sortCouponsByExpirationDate);

  return [...loyaltyCoupons, ...bonusPointDayCoupons, ...remainingCoupons, ...implicitCoupons];
}

export function* loyaltyCouponUpdateBPD(guestUser, allCoupons, flag) {
  const isSiteWidePromoAbtestEnabled = yield select(getIsSiteWidePromoAbTestEnabled);
  const couponCards = [];
  const lastMomentOfYear = getLastMomentOfYear();
  const couponDayStructuredData = {
    isExpiring: false,
    detailsOpen: false,
    effectiveDate: '',
    details: null,
    legalText: '',
    isStarted: true,
    offerType: 'BENEFITS',
    error: '',
    promotionType: 'public',
    expirationDateTimeStamp: lastMomentOfYear,
    isOnHold: 'false',
    mobileCouponError: '',
    isRedeemed: false,
    couponType: null,
    fromBonusPointsDay: true,
    isApplied: false,
  };

  try {
    yield call(getTierBenefits, {});
    const loyaltyBenefits = yield select(getLoyaltyBenefits);
    const { benefits = {}, productItems = [] } = loyaltyBenefits;
    let appliedBenefits = {};
    try {
      appliedBenefits = JSON.parse(JSON.stringify(benefits));
    } catch (e) {
      console.error('Failed to parse benefits:', e);
    }

    const isGiftwrapperApplied = appliedBenefits?.FreeGiftWrap;
    let statusUpdateBasketResponse = false;
    if (isGiftwrapperApplied) {
      statusUpdateBasketResponse = hasGiftOptionWithPromotion(productItems);
    }
    const loyaltyBonusPointDay = yield select(getLoyaltyTierBenefits);
    const remainingCount = calculateRemainingCounts(loyaltyBonusPointDay);
    if (remainingCount.BonusPoint > 0) {
      const bonusPointDayStructure = {
        ...couponDayStructuredData,
        id: BONUS_POINT,
        title: getValueFromResponse(loyaltyBonusPointDay, BONUS_POINT, 'name'),
        promotionId: 'BonusPointDay',
        perkLevel: 'BONUS POINT EVENT',
        originalOfferType: BONUS_POINT_DAY,
        availableToday: getValueFromResponse(
          loyaltyBonusPointDay,
          BONUS_POINT,
          'isApplicableToday'
        ),
        isLoyaltyBPDBlackoutDay: !getValueFromResponse(
          loyaltyBonusPointDay,
          BONUS_POINT,
          'isApplicableToday'
        ),
        status: getStatus(loyaltyBonusPointDay, BONUS_POINT),
        labelStatus: getValueFromResponse(loyaltyBonusPointDay, BONUS_POINT, IS_APPLIED_TO_BASKET)
          ? 'REMOVE'
          : 'APPLY',
        expirationDate: getExpirationDate(loyaltyBonusPointDay, BONUS_POINT),
        isExpired: getValueFromResponse(loyaltyBonusPointDay, BONUS_POINT, 'isExpired'),
      };
      couponCards.push(bonusPointDayStructure);
    }
    if (remainingCount.FreeGiftWrap > 0) {
      const freeGiftWrapStructure = {
        ...couponDayStructuredData,
        id: FREE_GIFT_WRAPPING,
        title: getValueFromResponse(loyaltyBonusPointDay, FREE_GIFT_WRAPPING, 'name'),
        promotionId: 'FreeGiftWrapping',
        perkLevel: 'FREE GIFT WRAPPING',
        originalOfferType: 'FREE-GIFT-WRAPPING',
        status: getValueFromResponse(loyaltyBonusPointDay, FREE_GIFT_WRAPPING, IS_APPLIED_TO_BASKET)
          ? 'applied'
          : 'available',
        labelStatus:
          getValueFromResponse(loyaltyBonusPointDay, FREE_GIFT_WRAPPING, IS_APPLIED_TO_BASKET) ||
          getValueFromResponse(loyaltyBonusPointDay, FREE_GIFT_WRAPPING, IS_ON_HOLD)
            ? 'REMOVE'
            : 'APPLY',
        expirationDate: getExpirationDate(loyaltyBonusPointDay, FREE_GIFT_WRAPPING),
        isExpired: getValueFromResponse(loyaltyBonusPointDay, FREE_GIFT_WRAPPING, 'isExpired'),
        isOnHold:
          getValueFromResponse(loyaltyBonusPointDay, FREE_GIFT_WRAPPING, IS_ON_HOLD).toString() ||
          statusUpdateBasketResponse.toString(),
      };
      couponCards.push(freeGiftWrapStructure);
    }
  } catch (e) {
    logger.error('Error fetching loyalty tier benefits', e);
  }
  const couponCachingTTL = yield select(BagPageSelectors.getCouponCachingTTL);
  const nonLoyaltyCoupons = yield select(getNormalCoupons);
  if (flag) {
    let coupons = [...nonLoyaltyCoupons, ...couponCards];
    const mergedCoupons = getFilteredAndSortedCouponList(coupons);
    const couponsArray = Array.from(new Set(mergedCoupons));

    coupons = siteWideCpnCheck({ isSiteWidePromoAbtestEnabled, couponsArray });
    return yield put(setCouponList({ coupons, couponCachingTTL }));
  }
  return [...allCoupons, ...couponCards];
}

export function* getAllCoupons(value) {
  const { payload = {} } = value;
  const { fromCSH } = payload;
  try {
    yield put(callCouponAction(true));
    const couponExpiryTimeDiff = yield select(getCouponExpiryTimeDifference);
    const { isSourceLogin = false, appliedCoupons = '' } = payload;
    const listOfAppliedCoupon = appliedCoupons ? getCouponCodeTypeMap(appliedCoupons) : [];

    const isCouponOnHoldNewDesignEnabled = yield select(getcouponOnHoldNewDesign);
    const isBonusPointDayEnabled = yield select(getIsBonusPointDayEnabled);
    const isLoyaltyTieringEnabled = yield select(getIsLoyaltyTieringEnabled);
    const isDateFixForMultiuseEnabled = yield select(getDateFixForMultiuseCoupons);
    let couponCachingTTL;
    if (payload.isAccountDrawer) {
      couponCachingTTL = yield select(getAccountDrawerMyCouponsCacheTTL);
    } else {
      couponCachingTTL = yield select(BagPageSelectors.getCouponCachingTTL);
    }

    const guestUser = yield select(getIsGuest);
    const fromPlcc = payload.fromPlcc || false;
    const isSiteWidePromoAbtestEnabled = yield select(getIsSiteWidePromoAbTestEnabled);
    let coupons;
    const deviceSpecificCoupon = yield select(getDeviceSpecificCouponList);
    coupons = yield call(
      getCouponsList,
      guestUser,
      fromPlcc,
      isSourceLogin,
      deviceSpecificCoupon,
      isSiteWidePromoAbtestEnabled
    );

    if (coupons && coupons.length) {
      coupons = processCouponStatus(coupons, listOfAppliedCoupon);
    }

    coupons = yield call(
      getNonWalletCouponList,
      listOfAppliedCoupon,
      isCouponOnHoldNewDesignEnabled,
      couponExpiryTimeDiff,
      coupons
    );
    if (coupons && coupons.length) {
      coupons = couponStatusUpdate({
        coupons,
        listOfAppliedCoupon,
        couponExpiryTimeDiff,
        isCouponOnHoldNewDesignEnabled,
        isSiteWidePromoAbtestEnabled,
        isDateFixForMultiuseEnabled,
      });
    }

    if (isBonusPointDayEnabled) {
      coupons = yield call(couponUpdateBPD, guestUser, coupons);
    }

    if (isLoyaltyTieringEnabled) {
      yield put(setNonLoyaltyCouponList(coupons));
      coupons = yield call(loyaltyCouponUpdateBPD, guestUser, coupons);
    }

    const mergedCoupons = getFilteredAndSortedCouponList(coupons);
    const couponsArray = Array.from(new Set(mergedCoupons));

    coupons = siteWideCpnCheck({ isSiteWidePromoAbtestEnabled, couponsArray });

    yield put(setCouponList({ coupons, couponCachingTTL }));
    if (!fromCSH && !isSourceLogin) yield put(setLoaderState(false));
    yield put(callCouponAction(false));
    yield put(hideLoader());
  } catch (e) {
    yield put(callCouponAction(false));
    logger.error('getAllCoupons error', e);
    if (!fromCSH) yield put(setLoaderState(false));
    yield put(hideLoader());
  }
}

export function* getCouponTermsAndConditions({ payload }) {
  let formData = { promotionId: payload?.promotionId };
  const resolve = payload?.formPromise?.resolve;
  const reject = payload?.formPromise?.reject;
  const { coupon } = payload;
  if (!formData?.promotionId) {
    formData = { promotionId: coupon?.promotionId };
  }
  try {
    yield put(setLoaderState(true));
    if (!payload.isAccountDashboard) {
      yield put(showLoader());
    }
    let couponsTermsNConditions = null;
    const loyaltyBenefits = yield select(getLoyaltyTierBenefits);
    if (loyaltyBenefits && payload) {
      const selectedBenefit = loyaltyBenefits.find((benefit) => benefit.type === payload.id);
      if (selectedBenefit) {
        const contentId = getContentID(selectedBenefit.type);
        if (contentId) {
          const result = yield call(getModuleX, contentId);
          couponsTermsNConditions = {
            legalText: result?.richText,
            promotionId: payload?.promotionId,
          };
          yield put(setCouponTermsAndConditions({ coupon: payload, couponsTermsNConditions }));
        }
      }
    }

    if (!couponsTermsNConditions) {
      couponsTermsNConditions = yield call(getCouponTermsAndConditionsAbstractor, formData);
      yield put(setCouponTermsAndConditions({ coupon: payload, couponsTermsNConditions }));
    }

    yield put(setLoaderState(false));
    yield put(hideLoader());
    resolve?.(couponsTermsNConditions);
  } catch (e) {
    logger.error('getCouponTermsNConditions error', e);
    yield put(setLoaderState(false));
    yield put(hideLoader());
    reject?.(e);
  }
}
export const getCouponDetailsTrackingObj = (formData, coupon, storeId, isFailed) => {
  const pageSectionName = pageTypeName(formData);
  const events = isFailed ? 'event151' : 'event150';
  const eventNameStr = isFailed ? 'invalid coupon code' : 'valid coupon code';

  return {
    customEvents: [events],
    eventName: eventNameStr,
    couponCode: coupon && coupon.id,
    storeId,
    pageSection: pageSectionName,
    pageType: pageSectionName,
    pageSubSection: pageSectionName,
    clickEvent: true,
    event151: isFailed ? '1' : '',
    event150: isFailed ? '' : '1',
  };
};

export function* getCouponDetails({ payload }) {
  const { formData } = payload;
  const storeId = yield select(getFavoriteStore);
  try {
    yield put(setGetCouponDetailsLoader(true));
    const coupon = yield call(getCouponDetailsAbstractor, formData);
    if (coupon) {
      const isCouponOnHoldNewDesignEnabled = yield select(getcouponOnHoldNewDesign);
      const couponExpiryTimeDiff = yield select(getCouponExpiryTimeDifference);
      const couponDescriptonFromPriceAdjustments = yield select(
        BagPageSelectors.getCouponDescriptonFromPriceAdjustments
      );
      const nonWalletCouponList = yield call(
        getPromotionDetails,
        [formData],
        undefined,
        isCouponOnHoldNewDesignEnabled,
        couponExpiryTimeDiff,
        couponDescriptonFromPriceAdjustments
      );
      coupon.legalText = nonWalletCouponList[0]?.legalText || '';
    }
    yield put(setCouponDetails({ coupon }));

    yield put(setGetCouponDetailsLoader(false));
    yield put(setClickAnalyticsData(getCouponDetailsTrackingObj(formData, coupon, storeId)));
    yield put(
      trackClick({
        name: 'can_not_apply_coupon_success',
        module: 'checkout',
      })
    );
  } catch (e) {
    if (e.message && !e.response && e.message !== COUPON_SELF_HELP_CONSTANT.EXPIRED_ERR_CODE) {
      yield put(setCouponDetailsError(e.message));
    } else if (e?.message === COUPON_SELF_HELP_CONSTANT.EXPIRED_ERR_CODE && e?.cause) {
      const coupon = {
        title: e?.cause?.description,
        expirationDate: e?.cause?.endDate,
      };
      yield put(setCouponDetailsError(e?.message));
      yield put(setCouponDetails({ coupon }));
    } else if (
      e?.response?.body?.errorCode &&
      e?.response?.body?.errorCode !== COUPON_SELF_HELP_CONSTANT.EXPIRED_ERR_CODE
    ) {
      yield put(setCouponDetailsError(e.response.body.errorCode));
    } else if (e?.response?.body?.errorCode === COUPON_SELF_HELP_CONSTANT.EXPIRED_ERR_CODE) {
      const coupon = {
        title: e?.response?.body?.description,
        expirationDate: e?.response?.body?.endDate,
      };
      yield put(setCouponDetailsError(e.response.body.errorCode));
      yield put(setCouponDetails({ coupon }));
    } else {
      yield put(setCouponDetailsError('Some Unexpected Error Occured'));
    }
    logger.error('getCouponDetails error', e);
    yield put(setGetCouponDetailsLoader(false));
    yield put(setClickAnalyticsData(getCouponDetailsTrackingObj(formData, null, storeId, true)));

    yield put(
      trackClick({
        name: 'can_not_apply_coupon_fail',
        module: 'checkout',
      })
    );
  }
}

export function* CouponSaga() {
  const cachedAllCoupons = validateReduxCache(getAllCoupons);
  yield takeLatest(COUPON_CONSTANTS.GET_COUPON_LIST, cachedAllCoupons);
  yield takeLatest(COUPON_CONSTANTS.GET_MY_REWARD_COUPON_LIST, getAllCoupons);
  yield takeEvery(COUPON_CONSTANTS.APPLY_COUPON, applyCoupon);
  yield takeLatest(COUPON_CONSTANTS.REMOVE_COUPON, removeCoupon);
  yield takeLatest(COUPON_CONSTANTS.GET_COUPON_TERMS_AND_CONDITIONS, getCouponTermsAndConditions);
  yield takeLatest(COUPON_CONSTANTS.GET_COUPON_DETAILS, getCouponDetails);
  yield takeLatest(COUPON_CONSTANTS.UPDATE_COUPON_LIST_ON_HOLD, updateOnHoldCoupons);
  yield takeLatest(COUPON_CONSTANTS.UPDATE_COUPON_LIST_EXPIRED, updateExpireCoupons);
  yield takeLatest(COUPON_CONSTANTS.APPLY_PLACE_BUCKS, applyMultipleCouponsSaga);
}

export default CouponSaga;
